import classNames from "classnames";
import { Icon } from "components";
import styles from "./TextField.module.css";

interface TextFieldProps {
  type?: "text" | "date" | "number" | "hidden";
  name?: string;
  label?: string;
  value?: string | number;
  defaultValue?: string | number;
  placeholder?: string;
  helper?: string;
  error?: string;
  iconStart?: string;
  iconEnd?: string;
  prefix?: string;
  suffix?: string;
  multiline?: boolean;
  readOnly?: boolean;
  style?: React.CSSProperties;
  onChange?: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
}

const TextField: React.FC<TextFieldProps> = ({
  type = "text",
  name,
  label,
  value,
  defaultValue,
  placeholder,
  helper,
  error,
  iconStart,
  iconEnd,
  prefix,
  suffix,
  multiline,
  readOnly,
  style,
  onChange,
}) => {
  const inputProps = {
    className: styles.input,
    type,
    id: name,
    name,
    placeholder,
    ...(value !== undefined && { value }),
    ...(defaultValue !== undefined && { defaultValue }),
    ...(readOnly && { readOnly, tabIndex: -1 }),
    ...(type === "date" && { required: true }), // hide clear icon on firefox
    ...(type === "number" && { min: 0 }),
    onChange,
  };

  const input = <input {...inputProps} />;
  const textArea = <textarea {...inputProps} rows={2} />;

  const containerClassName = classNames(
    styles.container,
    readOnly && styles.readOnly,
    type === "hidden" && styles.hidden
  );

  const inputContainerClassName = classNames(
    styles.inputContainer,
    multiline && styles.multiline
  );

  return (
    <div className={containerClassName} style={style}>
      {label && (
        <label className={styles.label} htmlFor={name}>
          {label}
        </label>
      )}

      <span className={inputContainerClassName}>
        {iconStart && <Icon name={iconStart} />}
        {prefix && <span className={styles.affix}>{prefix}</span>}
        {multiline ? textArea : input}
        {suffix && <span className={styles.affix}>{suffix}</span>}
        {iconEnd && <Icon name={iconEnd} />}

        {type === "date" && (
          <Icon className={styles.calendarIcon} name="calendar_today" />
        )}
      </span>

      {error && <span className={styles.error}>{error}</span>}
      {helper && <span className={styles.helper}>{helper}</span>}
    </div>
  );
};

export { TextField };
